import { AuxRadio, AuxDatePicker } from "@blk/aladdin-react-components-es";
import { AuxDatePickerDateFormatEnum, AuxDatePickerSeparatorsEnum } from "@blk/aladdin-web-components";
import { useGlobalization } from "components/ux/ins-date-pickers";
import { useWidgetCurrentDatePickerEndDate, useWidgetCurrentDatePickerStartDate, useWidgetCurrentTimePeriod } from "components/widgets/hooks/use-current-widget";
import { useGetSelectedReferenceDate } from "components/workspaces/hooks/use-current-dashboard";
import { regions } from "common/regions";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCurrentStatusSelectedRadioTimePeriod, setCurrentStatusDatePickerStartDate, setCurrentStatusDatePickerEndDate, updateDraftWorkspaceDateSettings } from "store/current-dashboard";
import { LastPeriods, TimePeriods } from "store/current-dashboard/types";
import { calculateStartAndEndDates, defaultTimePeriodDisplayValues } from "components/time-period/insSettingsTimePeriodHelper";
const DATE_SEPARATOR = AuxDatePickerSeparatorsEnum.FORWARD_SLASH;
const DEFAULT_LAST_PERIOD_STEP = 3;
const formatDateForPicker = (date, dateFormat) => {
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear());
    switch (dateFormat) {
        case AuxDatePickerDateFormatEnum.DD_MM_YYYY:
            return `${dd}${DATE_SEPARATOR}${mm}${DATE_SEPARATOR}${yyyy}`;
        case AuxDatePickerDateFormatEnum.YYYY_MM_DD:
            return `${yyyy}${DATE_SEPARATOR}${mm}${DATE_SEPARATOR}${dd}`;
        case AuxDatePickerDateFormatEnum.MM_DD_YYYY:
        default:
            return `${mm}${DATE_SEPARATOR}${dd}${DATE_SEPARATOR}${yyyy}`;
    }
};
const useDraftOrWorkspaceDateSettings = () => {
    const draft = useSelector((state) => state.currentDashboard?.draftWorkspaceSettings?.dateSettings);
    const workspace = useSelector((state) => state.currentDashboard?.workspaceSettings?.dateSettings);
    return {
        datePickerEndDate: draft?.datePickerEndDate ?? workspace?.datePickerEndDate,
        datePickerStartDate: draft?.datePickerStartDate ?? workspace?.datePickerStartDate,
        selectedRadio: draft?.selectedRadio ?? workspace?.selectedRadio ?? defaultTimePeriodDisplayValues.selectedRadio
    };
};
export const InsDateRange = (props) => {
    const referenceDate = useGetSelectedReferenceDate();
    const asOfDate = useMemo(() => referenceDate ?? new Date(), [referenceDate]);
    const dispatch = useDispatch(), draftValues = useDraftOrWorkspaceDateSettings(), { region } = useGlobalization(), isDashboard = props.isWidgetSettings === false, widgetDatepickerEndDate = useWidgetCurrentDatePickerEndDate(props.sectionId, props.widgetIds[0]), widgetDatepickerStartDate = useWidgetCurrentDatePickerStartDate(props.sectionId, props.widgetIds[0]), widgetSelectedRadio = useWidgetCurrentTimePeriod(props.sectionId, props.widgetIds[0]);
    const datepickerEndDate = isDashboard ? draftValues.datePickerEndDate : widgetDatepickerEndDate, datepickerStartDate = isDashboard ? draftValues.datePickerStartDate : widgetDatepickerStartDate, isSelected = (isDashboard ? draftValues.selectedRadio : widgetSelectedRadio) === TimePeriods.FromDateToDate, resolvedEndDate = datepickerEndDate ? new Date(datepickerEndDate) : new Date(asOfDate), resolvedStartDate = datepickerStartDate ? new Date(datepickerStartDate) : new Date(asOfDate);
    const dateFormat = regions[region]?.datePickerDateFormat ?? AuxDatePickerDateFormatEnum.MM_DD_YYYY;
    return (React.createElement("div", { className: "insRadioGroupDiv", key: TimePeriods.FromDateToDate },
        React.createElement(AuxRadio, { radioGroup: "timePeriod", eventData: TimePeriods.FromDateToDate, isChecked: isSelected, onRadioChanged: (event) => {
                const newRadio = event.detail.value.eventData;
                if (isDashboard) {
                    const defaultStart = calculateStartAndEndDates(DEFAULT_LAST_PERIOD_STEP, LastPeriods.Months, asOfDate).start;
                    dispatch(updateDraftWorkspaceDateSettings({
                        datePickerEndDate: datepickerEndDate ? resolvedEndDate : new Date(asOfDate),
                        datePickerStartDate: datepickerStartDate ? resolvedStartDate : defaultStart,
                        selectedRadio: newRadio
                    }));
                }
                else {
                    dispatch(setCurrentStatusSelectedRadioTimePeriod({ props, selectedRadio: newRadio }));
                }
            } }),
        React.createElement("div", { className: "insRadioGroupDiv" },
            React.createElement(AuxDatePicker, { className: "top-margin", dateFormat: dateFormat, displayDateFormat: dateFormat, separator: DATE_SEPARATOR, value: formatDateForPicker(resolvedStartDate, dateFormat), maxDate: formatDateForPicker(resolvedEndDate, dateFormat), isDisabled: !isSelected, closeCalendarOnBlur: false, size: "small", onValueChanged: (event) => {
                    const dateObject = event.detail?.dateObject;
                    if (dateObject) {
                        if (isDashboard) {
                            dispatch(updateDraftWorkspaceDateSettings({ datePickerStartDate: dateObject }));
                        }
                        else {
                            dispatch(setCurrentStatusDatePickerStartDate({ props, startDate: dateObject }));
                        }
                    }
                } }),
            React.createElement("span", { className: "radioGroupLabel" }, "\u00A0\u00A0\u2013\u00A0\u00A0"),
            React.createElement(AuxDatePicker, { className: "top-margin", dateFormat: dateFormat, displayDateFormat: dateFormat, separator: DATE_SEPARATOR, value: formatDateForPicker(resolvedEndDate, dateFormat), minDate: formatDateForPicker(resolvedStartDate, dateFormat), maxDate: formatDateForPicker(asOfDate, dateFormat), isDisabled: !isSelected, closeCalendarOnBlur: false, size: "small", onValueChanged: (event) => {
                    const dateObject = event.detail?.dateObject;
                    if (dateObject) {
                        if (isDashboard) {
                            dispatch(updateDraftWorkspaceDateSettings({ datePickerEndDate: dateObject }));
                        }
                        else {
                            dispatch(setCurrentStatusDatePickerEndDate({ endDate: dateObject, props }));
                        }
                    }
                } }))));
};
